import { getInsightsService } from '@app/promises/insights';
import { getCoreInstance } from '@app/stores/coreInstanceStore';
import { getReporters } from '@inter-ikea-storageone/shared/analytics/reporters';
import { getAnalyticsSceneArticles } from '@inter-ikea-storageone/shared/analytics/utils/analyticsSceneArticles';

export type {
  ReportArticle,
  BehaviorKey,
  MenuType,
  InteractionSource,
  WidgetMeta,
  BaseInteractionParams,
  InteractionMeta,
  InteractionParams
} from '@inter-ikea-storageone/shared/analytics/reporters';

const getSceneArticles = () =>
  Promise.resolve(
    getAnalyticsSceneArticles({
      core: getCoreInstance()
    })
  );

export const {
  reportAccountLogin,
  reportAccountLogout,
  reportAddArticle,
  reportAddCustomSlidingDoor,
  reportAddMultiFrameInteriorCombination,
  reportAddToCart,
  reportAddToWishlist,
  reportAssistanceCardLinkClick,
  reportAutoFillFrameDepthChange,
  reportAutoFillLegsToggled,
  reportAutoFillRecommendationChoice,
  reportBookRemotePlanning,
  reportChangeArticle,
  reportChangeCornerSolutionOrientation,
  reportChangePushOpenFunction,
  reportChangeSolutionFronts,
  reportChangeTv,
  reportCloseFilter,
  reportCloseModal,
  reportCopyArticle,
  reportCopyDesignCode,
  reportCreateNew,
  reportCurrentLocation,
  reportCustomVpcScreenshot,
  reportDoorVisibilityStatus,
  reportDeleteArticle,
  reportDesignErrorScreen,
  reportDoorPromptReply,
  reportFinancialServicesContinueButtonClick,
  reportFinancialServicesMoreInfoClick,
  reportFrontsOpeningFunctionSheetChoice,
  reportGoToSummary,
  reportInteractWithMenu,
  reportLandingPageSelectStart,
  reportMeasurementStatus,
  reportMemoryExceedsThreshold,
  reportMoveArticle,
  reportMoveTv,
  reportNavigateMenu,
  reportNavigation,
  reportNightModeStatus,
  reportOnSummaryClicked,
  reportOpenFilter,
  reportOpenProductInformation,
  reportOpenProductInformationContextMenu,
  reportOpenQrCode,
  reportPrint,
  reportProppingStatus,
  reportRedo,
  reportRemoveAllUnavailableProducts,
  reportRenderPrintQrCode,
  reportRoomSizeChange,
  reportRotate,
  reportSaveDesign,
  reportSaveDesignClick,
  reportSelectBlueDot,
  reportSelectEntity,
  reportSelectImage,
  reportSelectOpeningFunction,
  reportSelectReadyLayout,
  reportSelectTab,
  reportSetNoAvailability,
  reportSetPostcode,
  reportSetStoreLocation,
  reportShareDesignCardStateChange,
  reportShareViaClipboard,
  reportShareViaEmail,
  reportShareViaSms,
  reportSlantedWallShapeSelected,
  reportSlantedWallShapeSizeChange,
  reportSlantedWallSpaceExceededSheet,
  reportSortingApplied,
  reportSpotlightAction,
  reportSpotlightToggled,
  reportSummaryLoaded,
  reportToggleHamburgerMenu,
  reportToggleModal,
  reportToggleRoomSize,
  reportToggleSorting,
  reportTVStatus,
  reportUndo,
  reportUserLoggedIn,
  reportVpcInteraction,
  reportEnhancedImageRequested,
  reportEnhancedImageRequestFinished,
  reportExperimentalRelatedProductsAnalytics
} = getReporters({
  getInsightsService,
  getSceneArticles
});
